import { useState } from "react";

const Reorder = ({ setReorderPopup, order }) => {
  const [isBusy, setIsBusy] = useState(false);

  return (
    <button
      onClick={() => {
        setIsBusy(true);
        setReorderPopup({ open: true, data: order });
        setTimeout(() => {
          setIsBusy(false);
        }, 1000);
      }}
      className="btn btn-sm btn-icon btn-success-light btn-wave rounded-circle waves-effect waves-light"
      disabled={isBusy === true ? true : false}
    >
      {isBusy === true ? (
        <span
          className="spinner-border spinner-border-xs"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        <>
          <i className="ri-repeat-line"></i>
        </>
      )}
    </button>
  );
};

export default Reorder;
